<template>
  <div style="padding-top: 3em;">
    <h4 class="title">Building Inspection &amp; Notification Form</h4>
    <p>Pursuant to Section 59 of the Development Act 1993, a licensed building work contractor who is carrying out the work or who is in charge of carrying out the work must notify the Council within the prescribed period (1 days’ notice) of the commencement or completion of prescribed stages of work (a mandatory notification stage).</p>
    <br>

    <div v-if="message" class="notification is-primary">{{ message }}</div>

    <form-wizard
      dusk="form-wizard"
      @submit.prevent="onSubmit"
      @on-complete="onSubmit"
      shape="tab"
      color="#17C4EE"
      title
      subtitle
      ref="wizard"
      v-if="!message"
    >
      <input type="hidden" name="_token" :value="csrf">
      <input type="hidden" v-model="form">

      <div style="padding: 1em 0px; color: #aaa;">
        <small>* Required Fields</small>
      </div>

      <!-- ************************* -->
      <!-- TAB #1 - PROJECT RESPONSIBILITY -->
      <!-- ************************* -->
      <tab-content title="Project Responsibility" :before-change="validateStep1">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Who is the person responsible for the project? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="responsiblePersonProject"
                    name="responsiblePersonProject"
                    v-model="responsiblePersonProject"
                    :class="{ 'is-danger': $v.responsiblePersonProject.$error }"
                    @blur="$v.responsiblePersonProject.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Owner Builder</option>
                    <option>Licenced Builder</option>
                  </select>
                </div>
                <span
                  v-if="$v.responsiblePersonProject.$error && !$v.responsiblePersonProject.required"
                  class="help is-danger"
                >Person responsible is required</span>
              </div>
            </div>
          </div>
        </div>

        <!--         <template v-if="responsiblePersonProject=='Owner Builder'">
          <h2 class="title is-4">Owner Builder</h2>
        </template>
        <template v-if="responsiblePersonProject=='Licenced Builder'">
          <h2 class="title is-4">Licenced Builder</h2>
        </template>
        -->
        <template v-if="responsiblePersonProject">
          <template v-if="responsiblePersonProject=='Licenced Builder'">
            <div class="columns">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Company name *</label>
                  <div class="control">
                    <input
                      type="text"
                      id="builderCompanyName"
                      name="builderCompanyName"
                      v-model="builderCompanyName"
                      :status="$v.builderCompanyName.$error ? 'error' : null"
                      placeholder="Please enter the company name"
                      :class="{ 'input': true, 'is-danger': $v.builderCompanyName.$error }"
                      @blur="$v.builderCompanyName.$touch()"
                    >
                    <span
                      v-if="$v.builderCompanyName.$error && !$v.builderCompanyName.required"
                      class="help is-danger"
                    >Company name is required</span>
                    <span
                      v-if="$v.builderCompanyName.$error && !$v.builderCompanyName.AlphNumSpaceValidator"
                      class="help is-danger"
                    >Invalid characters entered</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-3">
                <div class="field">
                  <label class="label">Builders Licence Number *</label>
                  <div class="control">
                    <input
                      type="text"
                      name="builderLicenceNumber"
                      v-model="builderLicenceNumber"
                      :status="$v.builderLicenceNumber.$error ? 'error' : null"
                      placeholder="Please enter the builders licence"
                      :class="{ 'input': true, 'is-danger': $v.builderLicenceNumber.$error }"
                      @blur="$v.builderLicenceNumber.$touch()"
                    >
                    <span
                      v-if="$v.builderLicenceNumber.$error && !$v.builderLicenceNumber.required"
                      class="help is-danger"
                    >Builder Licence Number is required</span>
                    <span
                      v-if="$v.builderLicenceNumber.$error && !$v.builderLicenceNumber.AlphNumSpaceValidator"
                      class="help is-danger"
                    >Invalid characters entered</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="columns">
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  <template v-if="responsiblePersonProject=='Licenced Builder'">Contact&nbsp;</template>First name *
                </label>
                <div class="control">
                  <input
                    type="text"
                    name="contactFirstName"
                    v-model="contactFirstName"
                    :status="$v.contactFirstName.$error ? 'error' : null"
                    placeholder="Please enter the first name"
                    :class="{ 'input': true, 'is-danger': $v.contactFirstName.$error }"
                    @blur="$v.contactFirstName.$touch()"
                  >
                  <span
                    v-if="$v.contactFirstName.$error && !$v.contactFirstName.required"
                    class="help is-danger"
                  >First name is required</span>
                  <span
                    v-if="$v.contactFirstName.$error && !$v.contactFirstName.AlphNumSpaceValidator"
                    class="help is-danger"
                  >Invalid characters entered</span>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  <template v-if="responsiblePersonProject=='Licenced Builder'">Contact&nbsp;</template>Last name *
                </label>
                <div class="control">
                  <input
                    type="text"
                    name="contactLastName"
                    v-model="contactLastName"
                    :status="$v.contactLastName.$error ? 'error' : null"
                    placeholder="Please enter the last name"
                    :class="{ 'input': true, 'is-danger': $v.contactLastName.$error }"
                    @blur="$v.contactLastName.$touch()"
                  >
                  <span
                    v-if="$v.contactLastName.$error && !$v.contactLastName.required"
                    class="help is-danger"
                  >Last name is required</span>
                  <span
                    v-if="$v.contactLastName.$error && !$v.contactLastName.AlphNumSpaceValidator"
                    class="help is-danger"
                  >Invalid characters entered</span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <div class="field">
                <label class="label">Email Address *</label>
                <div class="control">
                  <input
                    type="text"
                    name="contactEmail"
                    v-model="contactEmail"
                    placeholder="Please enter email address"
                    :class="{ 'input': true, 'is-danger': $v.contactEmail.$error }"
                    @blur="$v.contactEmail.$touch()"
                  >
                  <span
                    v-if="$v.contactEmail.$error && !$v.contactEmail.required"
                    class="help is-danger"
                  >Email is required</span>
                  <span
                    v-if="$v.contactEmail.$error && !$v.contactEmail.email"
                    class="help is-danger"
                  >Valid email address required</span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <div class="field">
                <label class="label">Phone *</label>
                <div class="control">
                  <input
                    type="text"
                    name="contactPhone"
                    v-model="contactPhone"
                    placeholder="Please enter the phone number"
                    :class="{ 'input': true, 'is-danger': $v.contactPhone.$error }"
                    @blur="$v.contactPhone.$touch()"
                  >
                  <span
                    v-if="$v.contactPhone.$error && !$v.contactPhone.required"
                    class="help is-danger"
                  >Phone number is required</span>
                  <span
                    v-if="$v.contactPhone.$error && !$v.contactPhone.PhoneValidator"
                    class="help is-danger"
                  >Format incorrect</span>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Development Application No. *</label>
                <div class="control">
                  <ApplicationSearch
                    fieldName="developmentApplicationNumber"
                    source="/api/application/search"
                    placeholder="eg. 040/1234/19"
                    v-on:applicationNo="saveApplicationNo"
                    v-on:applicationNoTyping="saveApplicationNoTyping"
                    v-on:applicationNoProcessCtr="saveApplicationNoProcessCtr"
                  ></ApplicationSearch>
                  <span
                    v-if="$v.applicationNoProcessCtr.$error"
                    class="help is-danger"
                  >Valid application number is required.</span>
                  <small
                    v-if="$v.applicationNo.$invalid && !$v.applicationNo.DAValidator && applicationNoProcessCtr.length>0"
                    class="help is-danger"
                  >Invalid format.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">
                  Site Address
                  <small class="has-text-weight-light">
                    <strong>(Select from suggested address in dropdown list)</strong>
                  </small> *
                </label>

                <div class="control">
                  <PropertyAddress
                    fieldName="siteAddress"
                    source="/api/address/search"
                    placeholder="eg. 1/10 Main St Semaphore"
                    v-on:address="saveSiteAddress"
                    v-on:addressTyping="saveSiteAddressTyping"
                    v-on:addressPropertyNo="saveSitePropertyNo"
                  ></PropertyAddress>
                  <div
                    v-if="siteAddressPropertyNo==0 && siteAddressTyping.length>0"
                    style="background: #eee; padding: 1em;"
                  >
                    <small>
                      Please type address in full and then select correct address from the drop down list.
                      <br>eg. 1/10 Main St Semaphore SA 5091
                    </small>
                    <template
                      v-if="$v.siteAddressPropertyNo.$error || this.siteAddressNotFound == true"
                    >
                      (
                      <input
                        type="checkbox"
                        id="siteAddressNotFound"
                        v-model="siteAddressNotFound"
                      >
                      <label for="siteAddressNotFound">
                        <small>I cannot find my address in the dropdown list.</small>
                      </label> )
                    </template>
                  </div>
                  <span
                    v-if="$v.siteAddressPropertyNo.$error"
                    class="help is-danger"
                  >Valid address is required. (Please select from dropdown list as you type)</span>
                </div>
              </div>
            </div>
          </div>

          <template v-if="responsiblePersonProject=='Owner Builder'">
            <div class="columns">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Who is responsible for overseeing works? *</label>
                  <div class="control">
                    <div class="select" style="vertical-align: middle;">
                      <select
                        name="responsiblePersonWorks"
                        v-model="responsiblePersonWorks"
                        :class="{ 'is-danger': $v.responsiblePersonWorks.$error }"
                        @blur="$v.responsiblePersonWorks.$touch()"
                      >
                        <option selected :value="null">--Please select--</option>
                        <option>Registered Building Works Supervisor</option>
                        <option>Private Certifier</option>
                      </select>
                    </div>
                    <span
                      v-if="$v.responsiblePersonWorks.$error && !$v.responsiblePersonWorks.required"
                      class="help is-danger"
                    >Location is required</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="responsiblePersonWorks">
            <div class="columns">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Full name *</label>
                  <div class="control">
                    <input
                      type="text"
                      name="responsiblePersonWorksName"
                      v-model="responsiblePersonWorksName"
                      :status="$v.responsiblePersonWorksName.$error ? 'error' : null"
                      placeholder="Please enter the full name"
                      :class="{ 'input': true, 'is-danger': $v.responsiblePersonWorksName.$error }"
                      @blur="$v.responsiblePersonWorksName.$touch()"
                    >
                    <span
                      v-if="$v.responsiblePersonWorksName.$error && !$v.responsiblePersonWorksName.required"
                      class="help is-danger"
                    >Full name is required</span>
                    <span
                      v-if="$v.responsiblePersonWorksName.$error && !$v.responsiblePersonWorksName.AlphNumSpaceValidator"
                      class="help is-danger"
                    >Invalid characters entered</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Phone *</label>
                  <div class="control">
                    <input
                      type="text"
                      name="responsiblePersonWorksPhone"
                      v-model="responsiblePersonWorksPhone"
                      placeholder="Please enter the phone number"
                      :class="{ 'input': true, 'is-danger': $v.responsiblePersonWorksPhone.$error }"
                      @blur="$v.responsiblePersonWorksPhone.$touch()"
                    >
                    <span
                      v-if="$v.responsiblePersonWorksPhone.$error && !$v.responsiblePersonWorksPhone.required"
                      class="help is-danger"
                    >Phone number is required</span>
                    <span
                      v-if="$v.responsiblePersonWorksPhone.$error && !$v.responsiblePersonWorksPhone.PhoneValidator"
                      class="help is-danger"
                    >Format incorrect</span>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="responsiblePersonWorks=='Registered Building Works Supervisor'">
              <div class="columns">
                <div class="column is-3">
                  <div class="field">
                    <label class="label">Builders Licence Number *</label>
                    <div class="control">
                      <input
                        type="text"
                        name="responsiblePersonWorksLicenceNumber"
                        v-model="responsiblePersonWorksLicenceNumber"
                        :status="$v.responsiblePersonWorksLicenceNumber.$error ? 'error' : null"
                        placeholder="Please enter the builders licence"
                        :class="{ 'input': true, 'is-danger': $v.responsiblePersonWorksLicenceNumber.$error }"
                        @blur="$v.responsiblePersonWorksLicenceNumber.$touch()"
                      >
                      <span
                        v-if="$v.responsiblePersonWorksLicenceNumber.$error && !$v.responsiblePersonWorksLicenceNumber.required"
                        class="help is-danger"
                      >Builder Licence Number is required</span>
                      <span
                        v-if="$v.responsiblePersonWorksLicenceNumber.$error && !$v.responsiblePersonWorksLicenceNumber.AlphNumSpaceValidator"
                        class="help is-danger"
                      >Invalid characters entered</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>
      </tab-content>

      <!-- TAB 2 -->
      <tab-content title="Building Indemnity Insurance" :before-change="validateStep2">
        <div
          class="notification"
        >All persons with a building work contractor’s licence are required under the Building Work Contractors Act to take out a building indemnity insurance policy on any domestic building contract with an estimated value of $12000 or more, for which Development Approval is required. The insurance is intended to protect the building owner against non-completion of the building work and/or failure to rectify faulty work if the building work contractor dies, disappears or is declared bankrupt during the construction period of the five year structural warranty period.</div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Is building indemnity insurance required? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="buildingIndemnityInsuranceRequired"
                    v-model="buildingIndemnityInsuranceRequired"
                    :class="{ 'is-danger': $v.buildingIndemnityInsuranceRequired.$error }"
                    @blur="$v.buildingIndemnityInsuranceRequired.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.buildingIndemnityInsuranceRequired.$error && !$v.buildingIndemnityInsuranceRequired.required"
                  class="help is-danger"
                >This is required</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="buildingIndemnityInsuranceRequired=='Yes'">
          <div class="column is-6">
            <div class="field">
              <label class="label">Has building indemnity insurance been submitted? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="buildingIndemnityInsuranceSubmitted"
                    v-model="buildingIndemnityInsuranceSubmitted"
                    :class="{ 'is-danger': $v.buildingIndemnityInsuranceSubmitted.$error }"
                    @blur="$v.buildingIndemnityInsuranceSubmitted.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.buildingIndemnityInsuranceSubmitted.$error && !$v.buildingIndemnityInsuranceSubmitted.required"
                  class="help is-danger"
                >This is required</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="buildingIndemnityInsuranceSubmitted=='No'">
          <div class="column is-6">
            <div class="field">
              <label class="label">Have you obtained building indemnity insurance? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="buildingIndemnityInsuranceObtained"
                    v-model="buildingIndemnityInsuranceObtained"
                    :class="{ 'is-danger': $v.buildingIndemnityInsuranceObtained.$error }"
                    @blur="$v.buildingIndemnityInsuranceObtained.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.buildingIndemnityInsuranceObtained.$error && !$v.buildingIndemnityInsuranceObtained.required"
                  class="help is-danger"
                >This is required</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="buildingIndemnityInsuranceObtained=='Yes'">
          <div class="column is-8">
            <label class="label">Please attach building indemnity insurance certificate</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns" v-if="buildingIndemnityInsuranceObtained=='No'">
          <div class="column is-6">
            <div class="notification is-warning">
              A person
              <strong>must not</strong> commence domestic building work unless or until a copy of the certificate of Building Indemnity Insurance in relation to that work has been lodged with Council.
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content title="Inspection Details" :before-change="validateStep3">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Type of inspection? *</label>
              <div class="control">
                <template v-for="(item, index) in inspectionType">
                  <div :key="item.id">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="inspectionType"
                        :checked="item.selected"
                        @click="item.selected = !item.selected"
                      >
                      {{ item.type }}
                    </label>
                    <br>
                  </div>
                </template>

                <span
                  v-if="$v.inspectionTypeSelected.$error && !$v.inspectionTypeSelected.required"
                  class="help is-danger"
                >Inspection type is required</span>
              </div>
            </div>
          </div>
        </div>

        <template v-for="(item, index) in inspectionType">
          <template v-if="item.selected == true">
            <div :key="item.id">
              <div class="columns is-multiline">
                <div class="column is-10">
                  <div class="field">
                    <h3 class="title is-4" style="margin-top: 2em;">{{ item.type }}</h3>
                    <hr>
                    <label
                      class="label"
                      style="margin-bottom: 0; line-height: 1em;"
                    >{{ item.label }}</label>
                    <small>{{ item.description }}</small>
                    <div class="control" style="margin-top: .5em;">
                      <div date-picker-tip="Click icon to select date">
                        <input
                          type="text"
                          class="input"
                          style="width: 7em; float: left; display: inline;"
                          :value="customFormatter(item.date)"
                          readonly
                        >
                        <datepicker
                          :id="'datepicker' + index"
                          :name="'datepicker' + index"
                          v-model="item.date"
                          :initialView="'month'"
                          :format="customFormatter"
                          :disabled-dates="disabled"
                          :input-class="'input'"
                        ></datepicker>
                      </div>
                      <span v-if="item.ampm" class="select" style="vertical-align: middle;">
                        <select v-model="item.ampm">
                          <option :value="null">--Select--</option>
                          <option>AM</option>
                          <option>PM</option>
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.type == 'Framing'" class="columns is-multiline">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Building supervisors checklist already provided? *</label>
                    <div class="control">
                      <div class="select" style="vertical-align: middle;">
                        <select name="item.checklist" v-model="item.checklist">
                          <option selected :value="null">--Please select--</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                      <span
                        v-if="$v.buildingIndemnityInsuranceSubmitted.$error && !$v.buildingIndemnityInsuranceSubmitted.required"
                        class="help is-danger"
                      >This is required</span>
                    </div>
                  </div>
                </div>

                <div class="column is-10" v-if="item.checklist == 'No'">
                  <div class="field">
                    <label class="label">Please attach building supervisors checklist</label>
                    <FileDragDropInstant
                      v-on:fileIDs="appendFileIDs"
                      v-on:removeFileID="removeFileID"
                    ></FileDragDropInstant>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>

        <div class="columns" style="margin-top: 3em;">
          <div class="column is-6">
            <div class="field">
              <label class="label">Are there any site access issues? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select name="inspectionSiteAccessIssues" v-model="inspectionSiteAccessIssues">
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.inspectionSiteAccessIssues.$error && !$v.inspectionSiteAccessIssues.required"
                  class="help is-danger"
                >This is required</span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="inspectionSiteAccessIssues == 'Yes'">
          <template v-for="item in inspectionSiteAccessIssuesList">
            <div :key="item.id">
              <label class="checkbox">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="inspectionSiteAccessIssuesChecked"
                  :checked="item.selected"
                  @click="item.selected = !item.selected"
                >
                {{ item.issue }}
              </label>
              <template v-if="item.issue == 'Call prior to inspection' && item.selected == true">
                <br>
                <input
                  class="input is-small"
                  style="margin-bottom: 1em;margin-left: 1.2em;max-width: 150px;"
                  type="text"
                  name="inspectionSiteAccessCallPriorPhone"
                  v-model="inspectionSiteAccessCallPriorPhone"
                  placeholder="Enter phone number"
                >
                <span
                  v-if="$v.inspectionSiteAccessCallPriorPhone.$error && !$v.inspectionSiteAccessCallPriorPhone.required"
                  class="help is-danger"
                  style="display:inline;"
                >Phone number is required.</span>
              </template>
              <template v-if="item.issue == 'Other' && item.selected == true">
                <textarea
                  class="textarea"
                  name="inspectionSiteAccessOther"
                  v-model="inspectionSiteAccessOther"
                ></textarea>
                <span
                  v-if="$v.inspectionSiteAccessOther.$error && !$v.inspectionSiteAccessOther.required"
                  class="help is-danger"
                >Please provide comment</span>
              </template>
              <br>
            </div>
          </template>
          <span
            v-if="$v.inspectionSiteAccessIssuesChecked.$error && !$v.inspectionSiteAccessIssuesChecked.required"
            class="help is-danger"
          >A selection is required</span>
        </template>

        <div class="columns" style="margin-top: 3em;">
          <div class="column is-8">
            <div class="field">
              <label class="label">Additional Comments</label>
              <div class="control">
                <textarea
                  class="textarea"
                  name="inspectionComments"
                  v-model="inspectionComments"
                  placeholder="Please enter further comments..."
                ></textarea>
              </div>
              <span v-if="$v.inspectionComments.$error" class="help is-danger">Invalid Format.</span>
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content title="Privacy Policy" :before-change="validateStep4">
        <div class="columns">
          <div class="column is-8">
            <div class="notification is-warning" style="margin-bottom: 0px;">
              <div class="form-check">
                <label class="form-check-label" for="privacyAgreement">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="privacyAgreement"
                    id="privacyAgreement"
                    value="Yes"
                    :checked="privacyAgreement"
                    @click="privacyAgreement = !privacyAgreement"
                  >&nbsp;
                  By submitting this form, I consent to the City of Port Adelaide Enfield collecting, retaining and using my personal information provided in line with
                  <a
                    href
                    target="_blank"
                  >Council's Privacy Policy</a>.
                </label>
              </div>
            </div>
            <span
              v-if="$v.privacyAgreement.$error && !$v.privacyAgreement.required"
              class="help is-danger"
            >You must agree to the conditions.</span>
          </div>
        </div>
      </tab-content>

      <div class="column is-8" v-if="enableGoogleCaptch">
        <div class="field">
          <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="googleCaptchaKey"
          ></vue-recaptcha>
        </div>
      </div>

      <div class="modal" v-bind:class="{'is-active' : loading}">
        <div class="modal-background"></div>
        <div class="modal-content has-text-centered">
          <h1 class="title is-3 has-text-light">Please wait...</h1>
          <button
            class="button is-info is-loading is-fullwidth is-large"
            style="font-size: 5em; background: transparent;"
          >Submitting</button>
        </div>
      </div>

      <br>
      <br>
      <hr>
    </form-wizard>
  </div>
</template>
<script>
const isDate = value => moment(value, "DD/MM/YYYY", true).isValid();

import VueRecaptcha from "vue-recaptcha";

import PropertyAddress from "../../../../../../resources/assets/js/components/address/Typeahead-CouncilAddress.vue";
import GoogleAddressAutocomplete from "../../../../../../resources/assets/js/components/address/GoogleAddressAutocomplete.vue";

import ApplicationSearch from "../../../../../../resources/assets/js/components/address/Typeahead-Applications.vue";

import FileDragDropInstant from "../../../../../../Modules/FileManagement/Resources/assets/js/components/FileDragDropInstant.vue";

import {
  alpha,
  required,
  requiredIf,
  email,
  numeric,
  alphaNum,
  minValue,
  maxValue,
  minLength
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// Custom Validators
import { TimeValidator } from "../../../../../../resources/assets/js/validators/time-validator";
import { AlphNumCharsValidator } from "../../../../../../resources/assets/js/validators/alpha-num-chars-validator";
import { AlphNumSpaceValidator } from "../../../../../../resources/assets/js/validators/alpha-num-space-validator";
import { PhoneValidator } from "../../../../../../resources/assets/js/validators/phone-validator";
import { DAValidator } from "../../../../../../resources/assets/js/validators/development-application-validator";
import { MinDate } from "../../../../../../resources/assets/js/validators/min-date";

import moment from "moment";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import datepicker from "vuejs-datepicker";

export default {
  components: {
    FileDragDropInstant,
    PropertyAddress,
    GoogleAddressAutocomplete,
    ApplicationSearch,
    VueRecaptcha,
    FormWizard,
    TabContent,
    datepicker
  },
  props: {
    form: {}
  },
  data() {
    return {
      today: moment(new Date()).format("DD/MM/YYYY"),
      googleCaptchaKey: "6LcyrE0UAAAAAExxoj3NBm1vA-WMu88CIigyzkBU",
      enableGoogleCaptch: false,
      csrf: "",
      formTitle: this.form,
      message: "",
      submitted: false,
      loading: false,
      fileIDs: [],
      format: "dd/MM/yyyy",
      disabled: {
        to: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        )
      },
      //ProjectResponsibilty
      responsiblePersonProject: null,
      builderCompanyName: "",
      builderLicenceNumber: "",
      contactFirstName: "",
      contactLastName: "",
      contactEmail: "",
      contactPhone: "",
      siteAddress: "",
      siteAddressTyping: "",
      siteAddressPropertyNo: "",
      siteAddressNotFound: false,
      applicationNo: "",
      applicationNoTyping: "",
      applicationNoProcessCtr: 0,
      responsiblePersonWorks: null,
      responsiblePersonWorksName: "",
      responsiblePersonWorksPhone: "",
      responsiblePersonWorksLicenceNumber: "",
      //Insurance
      buildingIndemnityInsuranceRequired: null,
      buildingIndemnityInsuranceSubmitted: null,
      buildingIndemnityInsuranceObtained: null,
      //InspectionNotification
      inspectionTypeSelected: [],
      inspectionType: [
        {
          type: "Commencement",
          label: "Commencement Date *",
          description:
            "Commencement of building work on site including demolition, excavation and filling of land.",
          selected: false,
          date: new Date(moment())
        },
        {
          type: "Footing",
          label: "Preferred Inspection Date *",
          description:
            "Notification is to be provided at the completion of steel reinforcing prior to concrete pour.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        },
        {
          type: "Framing",
          label: "Preferred Inspection Date *",
          description:
            "Notification is to be provided at the completion of the wall and roof frame prior to the installation of any lining that may conceal it.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM",
          checklist: null
        },
        {
          type: "Designated Building Product",
          label: "Preferred Inspection Date *",
          description:
            "Intended commencement of the installation of a designated building product and the supervisor`s checklist.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        },
        {
          type: "Masonry/Firewall",
          label: "Preferred Inspection Date *",
          description:
            "At the completion of the fire protected wall between houses or tenancies including any fire resisting packing material.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        },
        {
          type: "Swimming Pool (Completion of Construction)",
          label: "Preferred Inspection Date *",
          description:
            "The builder or owner to notify their Council when the construction of a new swimming pool is completed, before it is filled with water.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        },
        {
          type:
            "Swimming Pool (Completion of Construction of a Safety Fence or Barrier)",
          label: "Preferred Inspection Date *",
          description:
            "Within two months of the completion of the swimming pool the builder or owner to notify their local Council when the construction of the approved swimming pool child safety barriers has been completed.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        },
        {
          type: "Completion",
          label: "Preferred Inspection Date *",
          description:
            "When all building work is completed, including the installation of smoke alarms, rainwater tanks and stormwater connections, and prior to the issuing of the Statement of Compliance under Schedule 19A.",
          selected: false,
          date: new Date(moment()),
          ampm: "AM"
        }
      ],
      // inspectionCommencementDate: new Date(moment()),
      // inspectionFootingInspectionDate: new Date(moment()),
      // inspectionFootingInspectionDateAMPM: null,
      // inspectionFramingInspectionDate: new Date(moment()),
      // inspectionFramingInspectionDateAMPM: null,
      // inspectionFramingSupervisorChecklistProvided: false,
      // inspectionDesignatedBuildingProductInspectionDate: new Date(moment()),
      // inspectionDesignatedBuildingProductInspectionDateAMPM: null,
      // inspectionMasonryFirewallInspectionDate: new Date(moment()),
      // inspectionMasonryFirewallInspectionDateAMPM: null,
      // inspectionSwimmingPoolInspectionDate: new Date(moment()),
      // inspectionSwimmingPoolInspectionDateAMPM: null,
      // inspectionSwimmingPoolBarriersInspectionDate: new Date(moment()),
      // inspectionSwimmingPoolBarriersInspectionDateAMPM: null,
      // inspectionCompletionInspectionDate: new Date(moment()),
      // inspectionCompletionInspectionDateAMPM: null,

      inspectionSiteAccessIssues: null,
      inspectionSiteAccessIssuesChecked: [],
      inspectionSiteAccessIssuesList: [
        {
          issue: "Call prior to inspection",
          selected: false
        },
        {
          issue: "Dog(s)",
          selected: false
        },
        {
          issue: "Locked Gates",
          selected: false
        },
        {
          issue: "Report to site officer",
          selected: false
        },
        {
          issue: "Other",
          selected: false
        }
      ],
      inspectionSiteAccessCallPriorPhone: "",
      inspectionSiteAccessOther: "",
      inspectionComments: "",
      privacyAgreement: false
    };
  },
  validations: {
    //TAB1
    responsiblePersonProject: { required },
    builderCompanyName: {
      AlphNumSpaceValidator,
      required: requiredIf(function() {
        return this.responsiblePersonProject == "Licenced Builder";
      })
    },
    builderLicenceNumber: {
      AlphNumSpaceValidator,
      required: requiredIf(function() {
        return this.responsiblePersonProject == "Licenced Builder";
      })
    },
    contactFirstName: { required, AlphNumSpaceValidator },
    contactLastName: { required, AlphNumSpaceValidator },
    contactEmail: { required, email },
    contactPhone: { required, PhoneValidator },
    applicationNo: { required, DAValidator },
    applicationNoProcessCtr: { required, minValue: minValue(1) },
    siteAddressPropertyNo: {
      required: requiredIf(function() {
        return this.siteAddressNotFound == false;
      })
    },

    responsiblePersonWorks: {
      required: requiredIf(function() {
        this.responsiblePersonProject == "Owner Builder";
      })
    },
    responsiblePersonWorksName: {
      AlphNumSpaceValidator,
      required: requiredIf(function() {
        return this.responsiblePersonWorks;
      })
    },
    responsiblePersonWorksPhone: {
      PhoneValidator,
      required: requiredIf(function() {
        return this.responsiblePersonWorks;
      })
    },
    responsiblePersonWorksLicenceNumber: {
      AlphNumSpaceValidator,
      required: requiredIf(function() {
        return (
          this.responsiblePersonWorks == "Registered Building Works Supervisor"
        );
      })
    },

    formStep1: [
      "responsiblePersonProject",
      "builderCompanyName",
      "builderLicenceNumber",
      "contactFirstName",
      "contactLastName",
      "contactEmail",
      "contactPhone",
      "applicationNo",
      "applicationNoProcessCtr",
      "siteAddressPropertyNo",
      "responsiblePersonWorks",
      "responsiblePersonWorksName",
      "responsiblePersonWorksPhone",
      "responsiblePersonWorksLicenceNumber"
    ],

    //TAB2
    buildingIndemnityInsuranceRequired: { required },
    buildingIndemnityInsuranceSubmitted: {
      required: requiredIf(function() {
        return this.buildingIndemnityInsuranceRequired == "Yes";
      })
    },
    buildingIndemnityInsuranceObtained: {
      required: requiredIf(function() {
        return this.buildingIndemnityInsuranceSubmitted == "No";
      })
    },

    formStep2: [
      "buildingIndemnityInsuranceRequired",
      "buildingIndemnityInsuranceSubmitted",
      "buildingIndemnityInsuranceObtained"
    ],

    //TAB3
    inspectionTypeSelected: { required },
    inspectionCommencementDate: {},
    inspectionFootingInspectionDate: {},
    inspectionFootingInspectionDateAMPM: {},
    inspectionFramingInspectionDate: {},
    inspectionFramingInspectionDateAMPM: {},
    inspectionFramingSupervisorChecklistProvided: {},
    inspectionDesignatedBuildingProductInspectionDate: {},
    inspectionDesignatedBuildingProductInspectionDateAMPM: {},
    inspectionMasonryFirewallInspectionDate: {},
    inspectionMasonryFirewallInspectionDateAMPM: {},
    inspectionSwimmingPoolInspectionDate: {},
    inspectionSwimmingPoolInspectionDateAMPM: {},
    inspectionSwimmingPoolBarriersInspectionDate: {},
    inspectionSwimmingPoolBarriersInspectionDateAMPM: {},
    inspectionCompletionInspectionDate: {},
    inspectionCompletionInspectionDateAMPM: {},
    inspectionSiteAccessIssues: { required },
    inspectionSiteAccessIssuesChecked: {
      required: requiredIf(function() {
        return this.inspectionSiteAccessIssues == "Yes";
      })
    },
    inspectionSiteAccessCallPriorPhone: {
      required: requiredIf(function() {
        return this.inspectionSiteAccessIssuesChecked.includes(
          "Call prior to inspection"
        );
      })
    },
    inspectionSiteAccessOther: {
      required: requiredIf(function() {
        return this.inspectionSiteAccessIssuesChecked.includes("Other");
      })
    },
    inspectionComments: {},

    formStep3: [
      "inspectionTypeSelected",
      "inspectionCommencementDate",
      "inspectionFootingInspectionDate",
      "inspectionFootingInspectionDateAMPM",
      "inspectionFramingInspectionDate",
      "inspectionFramingInspectionDateAMPM",
      "inspectionFramingSupervisorChecklistProvided",
      "inspectionDesignatedBuildingProductInspectionDate",
      "inspectionDesignatedBuildingProductInspectionDateAMPM",
      "inspectionMasonryFirewallInspectionDate",
      "inspectionMasonryFirewallInspectionDateAMPM",
      "inspectionSwimmingPoolInspectionDate",
      "inspectionSwimmingPoolInspectionDateAMPM",
      "inspectionSwimmingPoolBarriersInspectionDate",
      "inspectionSwimmingPoolBarriersInspectionDateAMPM",
      "inspectionCompletionInspectionDate",
      "inspectionCompletionInspectionDateAMPM",
      "inspectionSiteAccessIssues",
      "inspectionSiteAccessIssuesChecked",
      "inspectionSiteAccessCallPriorPhone",
      "inspectionSiteAccessOther",
      "inspectionComments"
    ],

    //TAB4
    privacyAgreement: { required },

    formStep4: ["privacyAgreement"]
  },
  watch: {
    message: function(val) {
      if (!val === "") {
        this.loading = false;
      }
    },
    inspectionType: {
      handler(val) {
        let self = this;
        this.inspectionTypeSelected = [];
        val.forEach(function(el, index) {
          if (el.selected == true) {
            self.inspectionTypeSelected.push(el.type);
          }
        });
      },
      deep: true
    },
    inspectionSiteAccessIssuesList: {
      handler(val) {
        let self = this;
        self.inspectionSiteAccessIssuesChecked = [];
        val.forEach(function(el, index) {
          if (el.selected == true) {
            self.inspectionSiteAccessIssuesChecked.push(el.issue);
          }
        });
      },
      deep: true
    }
  },
  computed: {
    fullName: function() {
      return this.contactFirstName + " " + this.contactLastName;
    },
    precis: function() {
      return (
        "Building Inspection Notification - " +
        this.applicationNo +
        " - " +
        (this.siteAddressPropertyNo > 0
          ? this.siteAddress
          : this.siteAddressTyping)
      );
    },
    formData: function() {
      var fields = {};

      fields.fileIDs = this.fileIDs;

      //TAB1
      fields.responsiblePersonProject = this.responsiblePersonProject;
      if (this.responsiblePersonProject == "Licenced Builder") {
        fields.builderCompanyName = this.builderCompanyName;
        fields.builderLicenceNumber = this.builderLicenceNumber;
      }

      fields.contactFirstName = this.contactFirstName;
      fields.contactLastName = this.contactLastName;
      fields.contactEmail = this.contactEmail;
      fields.contactPhone = this.contactPhone;
      fields.applicationNo = this.applicationNo;
      fields.applicationNoProcessCtr = this.applicationNoProcessCtr;
      fields.siteAddress =
        this.siteAddressPropertyNo > 0
          ? this.siteAddress
          : this.siteAddressTyping;
      fields.siteAddressPropertyNo =
        this.siteAddressPropertyNo > 0 ? this.siteAddressPropertyNo : 0;

      if (fields.siteAddressPropertyNo > 0) {
        fields.propertyNo = fields.siteAddressPropertyNo;
      }

      // fields.developmentApplicationNumber = this.developmentApplicationNumber;
      fields.responsiblePersonWorks = this.responsiblePersonWorks;
      fields.responsiblePersonWorksName = this.responsiblePersonWorksName;
      fields.responsiblePersonWorksPhone = this.responsiblePersonWorksPhone;
      if (
        this.responsiblePersonWorks == "Registered Building Works Supervisor"
      ) {
        fields.responsiblePersonWorksLicenceNumber = this.responsiblePersonWorksLicenceNumber;
      }

      //TAB2
      fields.buildingIndemnityInsuranceRequired = this.buildingIndemnityInsuranceRequired;
      if (this.buildingIndemnityInsuranceRequired == "Yes") {
        fields.buildingIndemnityInsuranceSubmitted = this.buildingIndemnityInsuranceSubmitted;
        if (this.buildingIndemnityInsuranceSubmitted == "No") {
          fields.buildingIndemnityInsuranceObtained = this.buildingIndemnityInsuranceObtained;
        }
      }

      //TAB3
      if (this.inspectionTypeSelected.length > 0) {
        fields.inspectionType = this.inspectionType;

        if (this.inspectionTypeSelected.includes("Commencement")) {
          fields.inspectionCommencementDate = this.inspectionCommencementDate;
        }

        if (this.inspectionTypeSelected.includes("Footing")) {
          fields.inspectionFootingInspectionDate = this.inspectionFootingInspectionDate;
          fields.inspectionFootingInspectionDateAMPM = this.inspectionFootingInspectionDateAMPM;
        }

        if (this.inspectionTypeSelected.includes("Framing")) {
          fields.inspectionFramingInspectionDate = this.inspectionFramingInspectionDate;
          fields.inspectionFramingInspectionDateAMPM = this.inspectionFramingInspectionDateAMPM;
          fields.inspectionFramingSupervisorChecklistProvided = this.inspectionFramingSupervisorChecklistProvided;
        }

        if (
          this.inspectionTypeSelected.includes("Designated Building Product")
        ) {
          fields.inspectionDesignatedBuildingProductInspectionDate = this.inspectionDesignatedBuildingProductInspectionDate;
          fields.inspectionDesignatedBuildingProductInspectionDateAMPM = this.inspectionDesignatedBuildingProductInspectionDateAMPM;
        }

        if (this.inspectionTypeSelected.includes("Masonry/Firewall")) {
          fields.inspectionMasonryFirewallInspectionDate = this.inspectionMasonryFirewallInspectionDate;
          fields.inspectionMasonryFirewallInspectionDateAMPM = this.inspectionMasonryFirewallInspectionDateAMPM;
        }

        if (
          this.inspectionTypeSelected.includes(
            "Swimming Pool Inspection (Initial Notification)"
          )
        ) {
          fields.inspectionSwimmingPoolInspectionDate = this.inspectionSwimmingPoolInspectionDate;
          fields.inspectionSwimmingPoolInspectionDateAMPM = this.inspectionSwimmingPoolInspectionDateAMPM;
        }

        if (
          this.inspectionTypeSelected.includes(
            "Swimming Pool Inspection (Safety Barriers)"
          )
        ) {
          fields.inspectionSwimmingPoolBarriersInspectionDate = this.inspectionSwimmingPoolBarriersInspectionDate;
          fields.inspectionSwimmingPoolBarriersInspectionDateAMPM = this.inspectionSwimmingPoolBarriersInspectionDateAMPM;
        }

        if (this.inspectionTypeSelected.includes("Completion")) {
          fields.inspectionCompletionInspectionDate = this.inspectionCompletionInspectionDate;
          fields.inspectionCompletionInspectionDateAMPM = this.inspectionCompletionInspectionDateAMPM;
        }
      }

      fields.inspectionSiteAccessIssues = this.inspectionSiteAccessIssues;

      if (this.inspectionSiteAccessIssues == "Yes") {
        fields.inspectionSiteAccessIssuesList = this.inspectionSiteAccessIssuesList;
        fields.inspectionSiteAccessCallPriorPhone = this.inspectionSiteAccessCallPriorPhone;
        fields.inspectionSiteAccessOther = this.inspectionSiteAccessOther;
      }

      fields.inspectionComments = this.inspectionComments;

      fields.precis = this.precis;
      fields.subject = "3.71.4.1";

      var actions = [];
      actions.push("A3.36.3.4");

      fields.action = actions;

      return JSON.stringify(fields);
    }
  },
  mounted() {
    this.csrf = window.laravel.csrfToken;
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 300);
    },

    // FILE ATTACHMENT HANDLING
    saveFileIDs(value) {
      this.fileIDs = value;
    },
    appendFileIDs(value) {
      let self = this;
      value.forEach(function(v) {
        if (self.fileIDs.indexOf(v) < 0) {
          self.fileIDs.push(v);
        }
      });
    },
    removeFileID(value) {
      this.fileIDs.splice(this.fileIDs.indexOf(value), 1);
    },

    // STEP VALIDATION
    validateStep1() {
      this.$v.formStep1.$touch();
      this.scrollToTop();
      return !this.$v.formStep1.$invalid;
    },
    validateStep2() {
      this.$v.formStep2.$touch();
      this.scrollToTop();
      return !this.$v.formStep2.$invalid;
    },
    validateStep3() {
      this.$v.formStep3.$touch();
      this.scrollToTop();
      return !this.$v.formStep3.$invalid;
    },

    validateStep4() {
      this.$v.formStep4.$touch();
      return !this.$v.formStep4.$invalid;
    },

    onSubmit() {
      if (this.validateStep4()) {
        if (this.enableGoogleCaptch) {
          this.$refs.invisibleRecaptcha.execute();
        } else {
          this.submitForm();
        }
      }
    },
    submitForm() {
      this.loading = true;
      console.log("starting");
      axios
        .post("/onlineform/" + this.form, {
          _token: this.csrf,
          formTitle: this.formTitle,
          fullName: this.fullName,
          emailAddress: this.contactEmail,
          contactNumber: this.contactPhone,
          precis: this.precis,
          formData: this.formData,
          message: ""
        })
        .then(response => {
          console.log(response.data.message);
          this.message = response.data.message;
          this.clear();
          //this.submitted = true
          setTimeout(() => (this.submitted = true), 5000);
          this.loading = false;
        });
    },
    clear() {},

    // SITE ADDRESS
    saveSiteAddress(value) {
      this.siteAddress = value;
    },
    saveSiteAddressTyping(value) {
      this.siteAddressTyping = value;
    },
    saveSitePropertyNo(value) {
      this.siteAddressPropertyNo = value;
    },
    clearSiteAddress() {
      this.siteAddress = "";
      this.siteAddressPropertyNo = "";
    },

    // APPLICATION NUMBER
    saveApplicationNo(value) {
      this.applicationNo = value;
    },
    saveApplicationNoTyping(value) {
      this.applicationNoTyping = value;
      //this.$set(this.applicationNoTyping, value);
    },
    saveApplicationNoProcessCtr(value) {
      this.applicationNoProcessCtr = value;
    },

    // DATE PICKER
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    checkInspectionCommencementDateError: function() {
      if (this.$v.inspectionCommencementDate.$error) {
        this.classInspectionCommencementDate = "is-danger";
      }
    },
    checkInspectionCommencementDateValue: function() {
      this.$v.inspectionCommencementDate.$touch();
      this.checkInspectionCommencementDateError();
    }
  }
};
</script>
<style>
#datepicker0,
#datepicker1,
#datepicker2,
#datepicker3,
#datepicker4,
#datepicker5,
#datepicker6,
#datepicker7,
#datepicker8,
#datepicker9 {
  float: left;
  color: rgba(0, 0, 0, 0);
  border: none;
  box-shadow: none;
  width: 3em;
  background: url("/images/UI/calendar-icon.png");
  background-size: contain;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/LayoutBuildingInspections.vue